import { render, staticRenderFns } from "./PrizeExchange.vue?vue&type=template&id=7b69cf33&scoped=true"
import script from "./PrizeExchange.vue?vue&type=script&lang=js"
export * from "./PrizeExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b69cf33",
  null
  
)

export default component.exports